// extracted by mini-css-extract-plugin
export default {"scrollSection":"MotorPage_scrollSection__E8B5+"};